import { render, staticRenderFns } from "./CockpitTable.vue?vue&type=template&id=04bc2517"
import script from "./CockpitTable.vue?vue&type=script&lang=js"
export * from "./CockpitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports